/* Apple iPhone StaggeredFadeIn, measured from apple.com/iphone (home/ck).
   A group plays once its top crosses 85vh. Each item rises 30px in 0.7s and
   fades in over 0.9s, 0.15s after the previous item, easeInOutQuad.
   Order is reading order: higher on the page first, then left to right. */
(function () {
  if (!document.documentElement || document.documentElement.dataset.leavesAppleReveal === '1') return;
  document.documentElement.dataset.leavesAppleReveal = '1';

  var DELAY = 0.15;
  var OPACITY_MS = 900;
  var MOVE_MS = 700;
  var RISE = 30;
  var ROW = 40;
  var EASE = 'cubic-bezier(0.455, 0.03, 0.515, 0.955)';

  var GROUPS = [
    {
      root: '.leaves-warm-flos',
      items: '.leaves-warm-flos__title, .leaves-warm-flos__shop, .leaves-warm-flos__card',
    },
    {
      root: '.leaves-canyon-feature',
      items:
        '.leaves-canyon-feature__title, .leaves-canyon-feature__body, .leaves-canyon-feature__shop, .leaves-canyon-feature__hero',
    },
    {
      root: '.leaves-patio-eisku',
      order: patioSequence,
      /* Start as the gray block approaches, not after the photos fill the screen. */
      anchor: '[data-section-id="leaves-e165"]',
      start: 1.2,
      delay: 0.08,
    },
  ];

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function show(el) {
    el.style.opacity = '1';
    el.style.transform = 'none';
  }

  function hide(el) {
    el.style.opacity = '0';
    el.style.transform = 'translate3d(0,' + RISE + 'px,0)';
  }

  function collect(root, selector) {
    return Array.prototype.filter.call(root.querySelectorAll(selector), function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      var rect = el.getBoundingClientRect();
      return rect.width > 1 && rect.height > 1;
    });
  }

  function onScreen(el) {
    var rect = el.getBoundingClientRect();
    var width = window.innerWidth || 800;
    return rect.left < width - 8 && rect.right > 8;
  }

  /* Which scene is a row: photo, then the center card, then the photos after it.
     The card's own pieces run top to bottom: arrows, copy, button.
     The photo sitting under the card is not its own step. */
  function patioSequence(root) {
    var cells = Array.prototype.filter.call(
      root.querySelectorAll('.leaves-patio-eisku__grid > .leaves-patio-eisku__cell:not([aria-hidden="true"])'),
      function (el) {
        var rect = el.getBoundingClientRect();
        return rect.width > 1 && rect.height > 1;
      }
    );
    if (!cells.length) return [];
    var story = [
      '.leaves-patio-eisku__arrow--prev',
      '.leaves-patio-eisku__arrow--next',
      '.leaves-patio-eisku__eyebrow',
      '.leaves-patio-eisku__title',
      '.leaves-patio-eisku__note',
      '.leaves-patio-eisku__cta',
    ]
      .map(function (selector) {
        return root.querySelector(selector);
      })
      .filter(function (el) {
        if (!el) return false;
        var cs = window.getComputedStyle(el);
        return cs.display !== 'none' && cs.visibility !== 'hidden';
      });
    var ordered = [];
    ordered.push(cells[0]);
    story.forEach(function (el) {
      ordered.push(el);
    });
    var i;
    for (i = 2; i < cells.length; i += 1) ordered.push(cells[i]);
    return ordered;
  }

  function readingOrder(nodes) {
    var boxes = nodes.map(function (el) {
      var rect = el.getBoundingClientRect();
      return { el: el, top: rect.top, left: rect.left };
    });
    boxes.sort(function (a, b) {
      if (Math.abs(a.top - b.top) > ROW) return a.top - b.top;
      return a.left - b.left;
    });
    return boxes.map(function (box) {
      return box.el;
    });
  }

  function play(nodes, step) {
    if (!nodes.length) return;
    if (reduced()) {
      nodes.forEach(show);
      return;
    }
    var gap = step == null ? DELAY : step;
    nodes.forEach(function (el, index) {
      var delay = index * gap * 1000;
      hide(el);
      var fade = el.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: OPACITY_MS,
        delay: delay,
        easing: EASE,
        fill: 'forwards',
      });
      el.animate(
        [{ transform: 'translate3d(0,' + RISE + 'px,0)' }, { transform: 'translate3d(0,0,0)' }],
        {
          duration: MOVE_MS,
          delay: delay,
          easing: EASE,
          fill: 'forwards',
        }
      );
      fade.onfinish = function () {
        show(el);
        el.getAnimations().forEach(function (anim) {
          anim.cancel();
        });
      };
    });
  }

  function arm(root, group) {
    if (root.getAttribute('data-apple-reveal') === '1') return;
    var nodes = group.order ? group.order(root) : collect(root, group.items);
    if (!nodes.length) return;
    root.setAttribute('data-apple-reveal', '1');
    if (reduced()) {
      nodes.forEach(show);
      return;
    }
    nodes.forEach(hide);

    function tryPlay() {
      var vh = window.innerHeight || 800;
      var box = group.anchor ? root.closest(group.anchor) || root : root;
      var line = group.start == null ? 0.85 : group.start;
      if (box.getBoundingClientRect().top > vh * line) return;
      window.removeEventListener('scroll', tryPlay);
      window.removeEventListener('resize', tryPlay);
      window.requestAnimationFrame(function () {
        var fresh = group.order ? group.order(root) : collect(root, group.items);
        if (!group.order) {
          var aside = fresh.filter(function (el) {
            return !onScreen(el);
          });
          aside.forEach(show);
          fresh = fresh.filter(onScreen);
          fresh = readingOrder(fresh);
        }
        play(fresh, group.delay);
      });
    }

    window.addEventListener('scroll', tryPlay, { passive: true });
    window.addEventListener('resize', tryPlay);
    tryPlay();
  }

  function scan() {
    GROUPS.forEach(function (group) {
      Array.prototype.forEach.call(document.querySelectorAll(group.root), function (root) {
        arm(root, group);
      });
    });
  }

  function boot() {
    scan();
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      scan();
      if (tries > 40) window.clearInterval(timer);
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
